import React from 'react'
import { Input, Button, Form, Checkbox } from 'antd'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import { saveIntegration } from '~/states/modules/integrations'

import logoClicksign from '~/assets/logo-clicksign.png'

const Clicksign = ({
	checkClicksign,
	onCheckClicksign,
	company,
	signatures_provider,
}) => {
	const [formClicksign] = Form.useForm()
	const dispatch = useDispatch()

	const saveIntegrationClicksign = () => {
		dispatch(
			saveIntegration({
				fields: { ...formClicksign.getFieldsValue(), company_id: company.id },
				clicksign: true,
			})
		)
		formClicksign.resetFields()
	}

	if (company && signatures_provider === 'clicksign') {
		formClicksign.setFieldsValue(company)
	}

	return (
		<div
			style={{
				padding: '30px 0 30px 0',
				borderTop: '1px solid #e8e8e8',
				borderBottom: '1px solid #e8e8e8',
			}}>
			<Checkbox
				style={{
					fontSize: '16px',
					color: 'black',
					fontWeight: '600',
				}}
				checked={checkClicksign}
				onChange={onCheckClicksign}>
				<img
					src={logoClicksign}
					style={{
						height: '47px',
						width: '47px',
						margin: '0 12px',
					}}
					alt="clicksign"
				/>
				Clicksign
			</Checkbox>
			<Form
				form={formClicksign}
				id="integrationClicksignForm"
				onFinish={saveIntegrationClicksign}>
				{checkClicksign ? (
					<div style={{ marginTop: '60px' }}>
						<Form.Item
							label="Access Token"
							name="clicksign_access_token"
							rules={[
								{ required: true, message: 'Este campo é obrigatório.' },
							]}>
							<Input value="" />
						</Form.Item>
						<div
							style={{
								display: 'flex',
								justifyContent: 'flex-end',
							}}>
							<Form.Item>
								<Button
									type="primary"
									htmlType="submit"
									form="integrationClicksignForm">
									Salvar
								</Button>
							</Form.Item>
						</div>
					</div>
				) : null}
			</Form>
		</div>
	)
}

Clicksign.propTypes = {
	checkClicksign: PropTypes.bool,
	onCheckClicksign: PropTypes.func,
	company: PropTypes.object,
	signatures_provider: PropTypes.string,
}

export default Clicksign
